import Vue from 'vue/dist/vue.js';

export default Vue.extend({
  template: `
            <span v-if="column === 'daysRemaning' || column === 'reccuringOverdue'" class="custom-tooltip" :style="{color: errorText}">{{fieldName}}</span>
            <span v-else v-show="text" class="custom-tooltip">{{fieldName}}: {{text}}</span>
    `,
  data: function () {
    return {
      fieldName: null,
      text: null,
      progress: null,
      column: false,
      errorText: false
    };
  },
  beforeMount() {
    var data = this.params.api.getDisplayedRowAtIndex(this.params.rowIndex).data;
    data.fieldName = this.params.fieldName || '';
    this.setState(data);
  },
  methods: {
    setState(obj) {
      Object.assign(this, obj);
    },
    refresh(params, row) {
      this.params = params;
      this.setText(params, row);
    },
    setText(params, row) {
      // console.log('row', row.type);
      // console.log('params', params);
      // console.log('params =-=-', params.colDef.field);
      this.column = params.colDef.field;

      if (params.colDef.field === 'daysRemaning' && params.value[0] === '+'){
        this.errorText = 'red'
      }

      this.text = params.value;
      switch(row.type){
        // TASK
        case 'task':
        case 'Task':
          if(params.colDef.field === 'taskStatus'){
            switch(params.value) {
              case 1:
                this.text = "Created";
                break;
              case 2:
                if (row.progress) this.text = "In Progress";
                else this.text = "Started";
                break;
              case 5:
                  this.text = "In Progress";
                break;
              case 3:
                this.text = "On Hold";
                break;
              case 4:
                this.text = "Done";
                break;
            }
          }
        break;
        // MASTER TASK
        case 'masterTask':
        case 'MasterTask':
          if (params.colDef.field === 'taskStatus') this.text = 'Parent Task';
          else if (params.colDef.field === 'daysTotal') this.text = null;
          else if (params.colDef.field === 'daysRemaning') {
            this.fieldName = null
            this.text = null;
          }
        break;
        // PROJECT
        case 'project':
        case 'businessUnit':
        case 'Engagement':
          if (params.colDef.field === 'taskStatus') {
            if (row.progress) this.text = "In Progress";
            else if (row.progress === 100) this.text = "Done";
            else this.text = "Created";
          }
        break;
      }
    }
  },
  created() {
    const data = this.params.api.getDisplayedRowAtIndex(this.params.rowIndex).data;
    this.setText(this.params, data);
  }
});
